(ns ycweb.app.website.cart.pages.payment-capture
  (:require
   [cemerick.url :as url]
   [rum.core :as rum]
   [ycweb.app.website.cart.pages.order-confirmation :as order-confirmation]
   [ycweb.app.website.cart.pages.payment.ebucks :as ebucks]
   [ycweb.app.website.cart.pages.payment.eft :as eft]
   [ycweb.app.website.cart.pages.payment.instore :as instore]
   [ycweb.app.website.cart.pages.payment.snapscan :as snapscan]
   [ycweb.app.website.cart.pages.payment.zapper :as zapper]
   [ycweb.app.website.cart.parts.common :as cart.common]
   [ycweb.components.common :as cmn]
   [ycweb.components.feedback :as feedback]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc unknown-method-page < rum/reactive cmn/cursors [app-atom process-atom order-atom]
  "Reached only by a routing mistake: the redirect-based methods (Card, Amex,
   Mobicred, Payflex, Discovery Miles) never render an in-page capture step. Say so and
   send the customer back to choose, instead of silently showing EFT bank details."
  (let [order (cmn/curact order-atom [:order])]
    (cart.common/checkout-layout process-atom false
      (list
        (rum/with-key
          (feedback/feedback :warning
            "We couldn't open that payment method."
            "Please choose your payment method again to continue.")
          "unknown-method")
        [:p {:key "unknown-method-link" :class "yc-paragraph yc-paragraph--flush u-margin-top-16"}
         [:a.text-link
          (urlstate/href-props app-atom "order" "ShowCart"
            {:orderid (:id order) :h (:h order) :step "payment/method-postcheckout"})
          "Choose a payment method"]])
      (cart.common/checkout-cta-sidebar-simple
        nil nil (:number order) order-atom {:total-key :balance}))))

;; Payment capture coordinating component
(rum/defc payment-capture-page < rum/reactive cmn/cursors [app-atom process-atom order-atom]
  "Coordinating component that dispatches to the appropriate payment method component"
  (let [screen-params (cmn/screen-params app-atom)
        selected-payment-method
        (or
          (when (:method screen-params) (url/url-decode (:method screen-params)))
          (cmn/curact order-atom [:cart :options :payment]))

        amount-owing (get-in (rum/react order-atom) [:totals :balance])]

    (cond (zero? amount-owing)
      (order-confirmation/order-confirmation-page app-atom process-atom order-atom)

      :else
      (case selected-payment-method
        "Transfer" (eft/eft-page app-atom process-atom order-atom)
        "Zapper" (zapper/zapper-page app-atom process-atom order-atom)
        "SnapScan" (snapscan/snapscan-page app-atom process-atom order-atom)
        "eBucks" (ebucks/ebucks-page app-atom process-atom order-atom)
        "InStore" (instore/instore-page app-atom process-atom order-atom)

        ;; Anything else is a routing mistake, not a request for bank details
        (unknown-method-page app-atom process-atom order-atom)))))

(defmethod cart.common/checkout-step :payment/capture
  [app-atom process-atom cart-atom]
  (let [order-atom (cmn/cursor-in app-atom [:order-summary])]
    (payment-capture-page app-atom process-atom order-atom)))

